import { render, staticRenderFns } from "./BudgetSegmentDrawer.vue?vue&type=template&id=dd5d7660&scoped=true&"
import script from "./BudgetSegmentDrawer.vue?vue&type=script&lang=js&"
export * from "./BudgetSegmentDrawer.vue?vue&type=script&lang=js&"
import style0 from "./BudgetSegmentDrawer.vue?vue&type=style&index=0&id=dd5d7660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5d7660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
